<template>
  <div class="form-page">
    <g-title tag="h1" size="s">
      Tack för allt du gjort - det var till mycket stor hjälp!
    </g-title>
    <br />
    <g-markdown :content="copy" />
    <br />
    <br />
    <br />
    <br />
  </div>
</template>
<script>
export default {
  data() {
    return {
      copy:
        'Om du har frågor eller funderingar om något som handlar om sexuella övergrepp får du gärna ringa oss på Ditt ECPAT, 020-112 100, chatta med oss eller mejla på [dittecpat.se](https://dittecpat.se/kontakta-oss/#mail-form), vi finns till för alla barn mellan 0 och 17 år på måndag till och med torsdag  mellan 17 - 22 och fredagar 15 -20.'
    };
  }
};
</script>

<style scoped></style>
